import "./reactive-element-CzWTglSF.js";
import { state as h } from "../beacon-state.d/index.js";
import { B as o } from "./breakpoints-CgRYFIVs.js";
import { p as u, m as g } from "./lifecycle-decorators-Cg3csm0R.js";
var k = Object.defineProperty, B = Object.getOwnPropertyDescriptor, m = (t) => {
  throw TypeError(t);
}, p = (t, e, r, n) => {
  for (var s = n > 1 ? void 0 : n ? B(e, r) : e, a = t.length - 1, i; a >= 0; a--)
    (i = t[a]) && (s = (n ? i(e, r, s) : i(s)) || s);
  return n && s && k(e, r, s), s;
}, M = (t, e, r) => e.has(t) || m("Cannot " + r), d = (t, e, r) => (M(t, e, "read from private field"), r ? r.call(t) : e.get(t)), c = (t, e, r) => e.has(t) ? m("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, r);
function w(t) {
  var e, r, n, s;
  let a = class extends t {
    constructor() {
      super(...arguments), this.smallBreakpointWatcher = window.matchMedia(
        a.createMediaQueryString(o.DEFAULT)
      ), this.mediumBreakpointWatcher = window.matchMedia(
        a.createMediaQueryString(o.MEDIUM)
      ), this.largeBreakpointWatcher = window.matchMedia(
        a.createMediaQueryString(o.LARGE)
      ), this.xLargeBreakpointWatcher = window.matchMedia(
        a.createMediaQueryString(o.XLARGE)
      ), this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches, this.isSmallBreakpoint = this.smallBreakpointWatcher.matches, this.isMediumBreakpoint = this.mediumBreakpointWatcher.matches, this.isLargeBreakpoint = this.largeBreakpointWatcher.matches, this.isXLargeBreakpoint = this.xLargeBreakpointWatcher.matches, c(this, e, ({ matches: i }) => {
        this.isSmallBreakpoint = i;
      }), c(this, r, ({ matches: i }) => {
        this.isMediumBreakpoint = i;
      }), c(this, n, ({ matches: i }) => {
        this.isLargeBreakpoint = i;
      }), c(this, s, ({ matches: i }) => {
        this.isXLargeBreakpoint = i;
      });
    }
    static createMediaQueryString(i) {
      return `(min-width: ${i}px)`;
    }
    /** Matches small but doesn't match medium. */
    get matchesUpToSmall() {
      return !this.isMediumBreakpoint;
    }
    /** Matches small and medium but doesn't match large. */
    get matchesUpToMedium() {
      return !this.isLargeBreakpoint;
    }
    /** Matches small, medium, and large but doesn't match x-large. */
    get matchesUpToLarge() {
      return !this.isXLargeBreakpoint;
    }
    /** Matches all breakpoints up to x-large. */
    get matchesUpToXLarge() {
      return this.isXLargeBreakpoint;
    }
    /** Alias for matching small and medium breakpoints. */
    get isMobile() {
      return this.matchesUpToMedium;
    }
    /** Alias for matching the large (desktop) breakpoint. */
    get isDesktop() {
      return this.isLargeBreakpoint;
    }
    prerenderWatchMediaSetup() {
      this.smallBreakpointWatcher.addEventListener(
        "change",
        d(this, e)
      ), this.mediumBreakpointWatcher.addEventListener(
        "change",
        d(this, r)
      ), this.largeBreakpointWatcher.addEventListener(
        "change",
        d(this, n)
      ), this.xLargeBreakpointWatcher.addEventListener(
        "change",
        d(this, s)
      );
    }
  };
  return e = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), p([
    h()
  ], a.prototype, "isSmallBreakpoint", 2), p([
    h()
  ], a.prototype, "isMediumBreakpoint", 2), p([
    h()
  ], a.prototype, "isLargeBreakpoint", 2), p([
    h()
  ], a.prototype, "isXLargeBreakpoint", 2), p([
    u
  ], a.prototype, "prerenderWatchMediaSetup", 1), a = p([
    g("WatchMedia")
  ], a), a;
}
export {
  w as W
};
